export default __webpack_public_path__ + "static/motel-outside2-c2a5912da8ad8fe18a038698674730de.jpg";